import styled from 'styled-components';
import { ApButtonMain, colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	margin: 0 auto;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const UploadWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 680px;
	min-width: 680px;
`;

export const HeaderPlaceholder = styled.div`
	border-top: 1px dashed ${colors.grey4};
`;

export const ExampleDownload = styled.div`
	display: flex;
	flex-direction: column;
	align-self: center;
	padding-bottom: 16px;
	width: 500px;
	text-align: center;
	align-items: center;

	> a {
		width: fit-content;
	}

	> span {
		font-size: 13px;
		line-height: 19px;
		color: ${colors.grey5};
		letter-spacing: 0.3px;
		padding-bottom: 16px;
	}
`;

export const StepContainer = styled.div`
	position: absolute;
	transform: translate(-9999px);
	opacity: 0;
	${({ visible }) =>
		visible ? 'position: static; transform: translate(0); opacity: 1;' : null};
`;

export const MapTaxonomyContainer = styled.div`
	display: flex;
	align-items: center;
	margin-top: 40px;
	width: 100%;
`;

export const MapTaxonomyButton = styled(ApButtonMain)`
	margin-right: 24px;
`;

export const MapTaxonomyText = styled.div`
	font-size: 16px;
	font-weight: 400;
`;

export const DownloadLink = styled.a`
	font-size: 13px;
	font-weight: 500;
	text-transform: uppercase;
	color: ${colors.grey8};
	padding: 0 8px;
	height: 36px;
	line-height: 36px;
	display: inline-block;

	&:hover {
		background: #ecf3ea;
	}
`;
